// ローカルストレージとのデータのやり取りを管理するユーティリティ関数

// 会話データをローカルストレージに保存
export const saveConversations = (conversations) => {
  try {
    // デバッグ用にファイル名が含まれているか確認
    const hasFilenames = conversations.some(conv => conv.sourceFilename);
    console.log(`保存前の会話データにファイル名が含まれているか: ${hasFilenames}`);
    if (hasFilenames) {
      const withFilename = conversations.filter(conv => conv.sourceFilename).length;
      console.log(`ファイル名を持つ会話数: ${withFilename}/${conversations.length}`);
      if (withFilename > 0) {
        console.log('ファイル名の例:', conversations.find(conv => conv.sourceFilename)?.sourceFilename);
      }
    }
    
    localStorage.setItem('ai_chat_conversations', JSON.stringify(conversations));
    
    // 保存後の確認
    const savedData = localStorage.getItem('ai_chat_conversations');
    const parsedData = JSON.parse(savedData);
    const savedHasFilenames = parsedData.some(conv => conv.sourceFilename);
    console.log(`保存後の会話データにファイル名が含まれているか: ${savedHasFilenames}`);
    
    return true;
  } catch (error) {
    console.error('会話データの保存に失敗しました:', error);
    return false;
  }
};

// 会話データをローカルストレージから取得
export const getConversations = () => {
  try {
    const data = localStorage.getItem('ai_chat_conversations');
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('会話データの取得に失敗しました:', error);
    return null;
  }
};

// テーマデータをローカルストレージに保存
export const saveThemes = (themes) => {
  try {
    localStorage.setItem('ai_chat_themes', JSON.stringify(themes));
    return true;
  } catch (error) {
    console.error('テーマデータの保存に失敗しました:', error);
    return false;
  }
};

// テーマデータをローカルストレージから取得
export const getThemes = () => {
  try {
    const data = localStorage.getItem('ai_chat_themes');
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('テーマデータの取得に失敗しました:', error);
    return null;
  }
};

// タグデータをローカルストレージに保存
export const saveTags = (tags) => {
  try {
    localStorage.setItem('ai_chat_tags', JSON.stringify(tags));
    return true;
  } catch (error) {
    console.error('タグデータの保存に失敗しました:', error);
    return false;
  }
};

// タグデータをローカルストレージから取得
export const getTags = () => {
  try {
    const data = localStorage.getItem('ai_chat_tags');
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('タグデータの取得に失敗しました:', error);
    return null;
  }
};

// ユーザー設定をローカルストレージに保存
export const saveSettings = (settings) => {
  try {
    localStorage.setItem('ai_chat_settings', JSON.stringify(settings));
    return true;
  } catch (error) {
    console.error('設定の保存に失敗しました:', error);
    return false;
  }
};

// ユーザー設定をローカルストレージから取得
export const getSettings = () => {
  try {
    const data = localStorage.getItem('ai_chat_settings');
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('設定の取得に失敗しました:', error);
    return null;
  }
};

// お気に入り情報をローカルストレージに保存
export const saveFavorites = (favoriteIds) => {
  try {
    localStorage.setItem('ai_chat_favorites', JSON.stringify(favoriteIds));
    return true;
  } catch (error) {
    console.error('お気に入りの保存に失敗しました:', error);
    return false;
  }
};

// お気に入り情報をローカルストレージから取得
export const getFavorites = () => {
  try {
    const data = localStorage.getItem('ai_chat_favorites');
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('お気に入りの取得に失敗しました:', error);
    return [];
  }
};

// 閲覧履歴をローカルストレージに保存
export const saveViewHistory = (viewHistory) => {
  try {
    localStorage.setItem('ai_chat_view_history', JSON.stringify(viewHistory));
    return true;
  } catch (error) {
    console.error('閲覧履歴の保存に失敗しました:', error);
    return false;
  }
};

// 閲覧履歴をローカルストレージから取得
export const getViewHistory = () => {
  try {
    const data = localStorage.getItem('ai_chat_view_history');
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('閲覧履歴の取得に失敗しました:', error);
    return [];
  }
};

// 保存済みキーワードをローカルストレージに保存
export const saveKeywords = (keywords) => {
  try {
    localStorage.setItem('ai_chat_keywords', JSON.stringify(keywords));
    return true;
  } catch (error) {
    console.error('キーワードデータの保存に失敗しました:', error);
    return false;
  }
};

// 保存済みキーワードをローカルストレージから取得
export const getKeywords = () => {
  try {
    const data = localStorage.getItem('ai_chat_keywords');
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('キーワードデータの取得に失敗しました:', error);
    return [];
  }
};

// 全データをエクスポート
export const exportAllData = () => {
  try {
    const conversations = getConversations() || [];
    const themes = getThemes() || [];
    const tags = getTags() || [];
    const favorites = getFavorites() || [];
    const viewHistory = getViewHistory() || [];
    const settings = getSettings() || {};
    const keywords = getKeywords() || [];
    
    // 会話データにお気に入り情報を追加
    const conversationsWithFavorite = conversations.map(conv => {
      return {
        ...conv,
        favorite: favorites.includes(conv.id)
      };
    });
    
    return {
      conversations: conversationsWithFavorite,
      themes,
      tags,
      favorites,
      viewHistory,
      settings,
      keywords,
      exportDate: new Date().toISOString()
    };
  } catch (error) {
    console.error('データのエクスポートに失敗しました:', error);
    return null;
  }
};

// データのインポート
export const importAllData = (data, overwriteExisting = false, importFilename = '') => {
  try {
    // ファイル名が空の場合はデフォルト名を使用するが、警告を表示
    if (!importFilename || importFilename.trim() === '') {
      console.warn('インポートファイル名が指定されていません。デフォルト名を使用します。');
      importFilename = 'インポートデータ';
    }
    
    console.log('インポート処理: 実際のファイル名を使用します:', importFilename);
    
    const skippedItems = {
      conversations: [],
      themes: [],
      keywords: []
    };
    // 会話データのマージ
    if (data.conversations) {
      const existingConversations = getConversations() || [];
      
      // IDをキーとしたマップを作成
      const conversationMap = {};
      existingConversations.forEach(conv => {
        conversationMap[conv.id] = conv;
      });
      
      // 新しい会話をマージ
      data.conversations.forEach(newConv => {
        const existingConv = conversationMap[newConv.id];
        
        // 必ず実際のファイル名を設定
        newConv.sourceFilename = importFilename;
        // 互換性のために複数のプロパティに同じファイル名を設定
        newConv.filename = importFilename;
        newConv.file = importFilename;
        
        console.log(`会話 ${newConv.id} にファイル名を設定: ${importFilename}`);
        // デバッグ用に確認
        console.log('設定後の会話データ:', JSON.stringify({
          id: newConv.id,
          sourceFilename: newConv.sourceFilename,
          filename: newConv.filename,
          file: newConv.file
        }));
        
        if (!existingConv) {
          // 既存の会話がない場合は追加
          conversationMap[newConv.id] = newConv;
          console.log(`会話追加: ${newConv.id}, ファイル名: ${newConv.sourceFilename || 'なし'}`);
        } else if (overwriteExisting) {
          // 上書きが許可されている場合は上書き
          conversationMap[newConv.id] = newConv;
          console.log(`会話上書き: ${newConv.id}, ファイル名: ${newConv.sourceFilename || 'なし'}`);
        } else {
          // 既存の会話がある場合は、既存データを完全に保護
          // お気に入り状態も既存のものを維持
          skippedItems.conversations.push(newConv.id);
          console.log(`会話スキップ (既存データ完全保護): ${newConv.id}, 既存favorite: ${existingConv.favorite}`);
        }
      });
      
      // マップを配列に戻す
      const mergedConversations = Object.values(conversationMap);
      
      // デバッグ用にファイル名が含まれているか確認
      const hasFilenames = mergedConversations.some(conv => conv.sourceFilename);
      console.log(`マージ後の会話データにファイル名が含まれているか: ${hasFilenames}`);
      if (hasFilenames) {
        const withFilename = mergedConversations.filter(conv => conv.sourceFilename).length;
        console.log(`ファイル名を持つ会話数: ${withFilename}/${mergedConversations.length}`);
        console.log('ファイル名の例:', mergedConversations.find(conv => conv.sourceFilename)?.sourceFilename);
      }
      
      console.log('保存前の会話データ例:', mergedConversations[0]);
      saveConversations(mergedConversations);
      
      // 会話データに含まれるfavoriteフィールドを処理（上書き許可時のみ）
      if (overwriteExisting) {
        const existingFavorites = getFavorites() || [];
        const newFavorites = new Set(existingFavorites);
        
        // 各会話のfavoriteフィールドをチェック
        data.conversations.forEach(conv => {
          if (conv.favorite === true) {
            newFavorites.add(conv.id);
          } else if (conv.favorite === false && newFavorites.has(conv.id)) {
            newFavorites.delete(conv.id);
          }
        });
        
        // 更新されたお気に入りを保存
        saveFavorites(Array.from(newFavorites));
      }
    }
    
    // テーマデータのマージ
    if (data.themes) {
      const existingThemes = getThemes() || [];
      const themeMap = {};
      existingThemes.forEach(theme => {
        themeMap[theme.id] = theme;
      });
      
      data.themes.forEach(newTheme => {
        const existingTheme = themeMap[newTheme.id];
        
        if (!existingTheme) {
          // 既存のテーマがない場合は追加
          themeMap[newTheme.id] = newTheme;
          console.log(`テーマ追加: ${newTheme.id}`);
        } else if (overwriteExisting) {
          // 上書きが許可されている場合は上書き
          themeMap[newTheme.id] = newTheme;
          console.log(`テーマ上書き: ${newTheme.id}`);
        } else {
          // 既存のテーマを保護
          skippedItems.themes.push(newTheme.id);
          console.log(`テーマスキップ (既存保護): ${newTheme.id}`);
        }
      });
      
      const mergedThemes = Object.values(themeMap);
      saveThemes(mergedThemes);
    }
    
    // タグデータのマージ
    if (data.tags) {
      const existingTags = getTags() || [];
      const tagSet = new Set([...existingTags, ...data.tags]);
      const mergedTags = Array.from(tagSet);
      saveTags(mergedTags);
    }
    
    // お気に入りデータのマージ (従来の方法 - favorites配列)
    if (data.favorites) {
      const existingFavorites = getFavorites() || [];
      const favoriteSet = new Set([...existingFavorites, ...data.favorites]);
      const mergedFavorites = Array.from(favoriteSet);
      saveFavorites(mergedFavorites);
    }
    
    // 閲覧履歴データのマージ
    if (data.viewHistory) {
      const existingViewHistory = getViewHistory() || [];
      // 閲覧履歴は重複を排除しないで単純に結合
      const mergedViewHistory = [...existingViewHistory, ...data.viewHistory];
      saveViewHistory(mergedViewHistory);
    }
    
    // 設定データは上書きでよい
    if (data.settings) {
      const existingSettings = getSettings() || {};
      const mergedSettings = { ...existingSettings, ...data.settings };
      saveSettings(mergedSettings);
    }
    
    // キーワードデータのマージ
    if (data.keywords) {
      const existingKeywords = getKeywords() || [];
      
      // IDをキーとしたマップを作成
      const keywordMap = {};
      existingKeywords.forEach(keyword => {
        keywordMap[keyword.id] = keyword;
      });
      
      // 新しいキーワードをマージ
      data.keywords.forEach(newKeyword => {
        const existingKeyword = keywordMap[newKeyword.id];
        
        if (!existingKeyword) {
          // 既存のキーワードがない場合は追加
          keywordMap[newKeyword.id] = newKeyword;
          console.log(`キーワード追加: ${newKeyword.id}`);
        } else if (overwriteExisting) {
          // 上書きが許可されている場合は上書き
          keywordMap[newKeyword.id] = newKeyword;
          console.log(`キーワード上書き: ${newKeyword.id}`);
        } else {
          // 既存のキーワードを保護
          skippedItems.keywords.push(newKeyword.id);
          console.log(`キーワードスキップ (既存保護): ${newKeyword.id}`);
        }
      });
      
      // マップを配列に戻して保存
      const mergedKeywords = Object.values(keywordMap);
      saveKeywords(mergedKeywords);
      console.log(`キーワードデータをマージしました: 既存=${existingKeywords.length}, 新規=${data.keywords.length}, 結果=${mergedKeywords.length}`);
    }
    
    return {
      success: true,
      skippedItems: skippedItems
    };
  } catch (error) {
    console.error('データのインポートに失敗しました:', error);
    return {
      success: false,
      skippedItems: null
    };
  }
};

// すべてのデータを削除
export const clearAllData = () => {
  try {
    // すべてのデータキーを削除
    localStorage.removeItem('ai_chat_conversations');
    localStorage.removeItem('ai_chat_themes');
    localStorage.removeItem('ai_chat_tags');
    localStorage.removeItem('ai_chat_settings');
    localStorage.removeItem('ai_chat_favorites');
    localStorage.removeItem('ai_chat_view_history');
    localStorage.removeItem('ai_chat_keywords');
    
    console.log('すべてのデータが正常に削除されました');
    return true;
  } catch (error) {
    console.error('データの削除に失敗しました:', error);
    return false;
  }
};

// 空のデータを初期化する関数
export const initializeEmptyData = () => {
  // 空の配列や初期設定を保存
  saveConversations([]);
  saveThemes([]);
  saveTags([]);
  saveFavorites([]);
  
  // デフォルト設定
  saveSettings({
    theme: 'light',
    language: 'ja',
    reminderEnabled: true,
    defaultView: 'timeline'
  });
  
  // 空のキーワードリストを初期化
  saveKeywords([]);
  
  // 空の閲覧履歴を初期化
  saveViewHistory([]);
  
  return true;
};
